export const START_LOGIN = 'START_LOGIN';
export const POST_LOGIN = 'POST_LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGOUT = 'LOGOUT';
export const POST_LOGOUT = 'POST_LOGOUT';

export const LOCAL_AUTH_CHECK = 'LOCAL_AUTH_CHECK';
export const LOCAL_AUTH_COMPLETED = 'LOCAL_AUTH_COMPLETED';
export const CALL_CHECKPOINT = 'CALL_CHECKPOINT';